import React from "react";

function NotFound() {
  return (
    <div className="flex flex-row justify-center items-center gap-4 p-36">
      <h3 className="font-bold">404</h3>|<p>Not Found</p>
    </div>
  );
}

export default NotFound;
